import Helper from './Helper';

class LinkHandler {
  constructor() {
    const links = Array.prototype.slice.call(document.querySelectorAll('a[href]'));
    if(!!NSContext){
      links.forEach(element => {
        if(!element.href.includes(NSContext.site.siteUrl.replace('/wp', ''))){
          element.target = '_blank';
        }
      });
    }
  }
}
export default LinkHandler;
